import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';

const { Title, Text } = Typography;

// Shared layout for public legal pages (Privacy Policy, Terms of Use).
// Rendered outside the auth gate so it stays reachable when logged out —
// required for app store review and the Google OAuth consent screen.
const LegalPage = ({ title, effectiveDate, orgName, children }) => (
  <div style={{ display: 'flex', justifyContent: 'center', minHeight: '100vh', overflowY: 'auto', width: '100vw' }}>
    <div style={{ maxWidth: '760px', padding: '40px 24px 80px', width: '100%' }}>
      <Title level={1}>{title}</Title>
      <Text type="secondary">{orgName} · Effective {effectiveDate}</Text>
      <div style={{ marginTop: '24px' }}>{children}</div>
      <div style={{ marginTop: '48px' }}>
        <Link to="/login">← Back to sign in</Link>
      </div>
    </div>
  </div>
);

LegalPage.propTypes = {
  title: PropTypes.string.isRequired,
  effectiveDate: PropTypes.string.isRequired,
  orgName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LegalPage.defaultProps = {
  orgName: 'Acts 2 Network',
};

export default LegalPage;
